import type { AdminSectionProps } from './types'
import { CloudAccountSection } from './CloudAccountSection'
import { AtolDiagnosticsCard } from '@core/components/AtolDiagnosticsCard'
import { AppUpdateCard } from '@core/components/AppUpdateCard'
import { ModuleCard } from './ModuleCard'
import { AdminCard } from './AdminCard'
import { useAuthToken } from './useAuthToken'

/**
 * Раздел «Интеграции»: облако + карточки модулей юрисдикции.
 *
 * Экраны модулей ядру неизвестны: они приходят дескрипторами из реестра,
 * а `ModuleCard` рисует заголовок с галочкой и сворачивает блок при выключении.
 * Диагностика АТОЛ и обновление приложения нужны редко — они свёрнуты.
 */
export function IntegrationsSection({ core, cashier, setupOnly }: AdminSectionProps) {
  const token = useAuthToken()
  const canEditModuleSettings = cashier == null || cashier.role === 'admin'
  const modulesCount = core.moduleUi.list().length

  const meta = (text: string) => (
    <span className="text-small font-normal text-muted">{text}</span>
  )

  return (
    <>
      <AdminCard
        id="integrations.cloud"
        title="Подключение к облаку"
        defaultOpen
        meta={meta(token ? 'подключено' : 'нет входа')}
      >
        <CloudAccountSection />
      </AdminCard>

      {!setupOnly &&
        core.moduleUi.list().map((descriptor) => (
          <ModuleCard
            key={descriptor.id}
            core={core}
            descriptor={descriptor}
            canEdit={canEditModuleSettings}
          />
        ))}

      <AdminCard
        id="integrations.atol"
        title="Диагностика Android / ATOL"
        meta={modulesCount > 0 ? meta(`модулей: ${modulesCount}`) : undefined}
      >
        <AtolDiagnosticsCard />
      </AdminCard>

      <AdminCard id="integrations.update" title="Обновление приложения">
        <AppUpdateCard />
      </AdminCard>
    </>
  )
}
